export default __webpack_public_path__ + "static/1598-0d14a2ad94d06ae3468f07f2280a8277.gif";